import ActionButton from 'Components/ActionButton';
import ConfirmationDialog from 'Components/ConfirmationDialog';
import FormRow from 'Components/FormRow';
import { Container, Item } from 'Components/Grid';
import InputHandler from 'Components/InputHandler';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { useAppSelector } from 'Store/index';
import { openPDFOnclick } from '.';
import colors from '../../../config/theme/colors';
import { AttachmentForm } from '../../_NewElements/GeneralForms/AttachmentsForm';
import AttachmentDialog from './AttachmentDialog';
import PatientList from './PatientList';

import type { TAttachmentData } from '.';
import type { TTOPIC } from 'Store/messaging/types/TTopic';

const GroupMessageForm = ({
  formValues,
  onChange,
  cancelGroupMessage,
  sendGroupMessage,
  topic,
  attachmentData,
  handleFileChange,
  existingAttachments,
  deleteAttachment,
}: IGroupMessageForm) => {
  const stateGroupMessagePatients = useAppSelector(s => s.session.messagingSessionSettings.groupMessagePatients);

  const { formatMessage } = useIntl();
  const fm = (id: string) => formatMessage({ id });
  const [openAttachmentId, setOpenAttachmentId] = React.useState<string | null>(null);

  const [attachmentDeletionID, setAttachmentDeletionID] = React.useState<string | null>(null);

  return (
    <div>
      {/* <FormRow title="messaging.messageDate">
        <InputHandler
          type="PartialDate"
          name="date"
          editing={true}
          formData={{ document: { date: formValues?.['date'] }, onChange: onChange('date') }}
          dateDefault={'now'}
        />
      </FormRow> */}
      {/* <FormRow title="messaging.messageEndDate">
        <InputHandler
          type="PartialDate"
          name="endDate"
          editing={true}
          formData={{ document: { date: formValues?.['endDate'] }, onChange: onChange('endDate') }}
        />
      </FormRow> */}
      <FormRow title="messaging.recipients2">
        <PatientList
          topic={topic}
          patientIdList={!topic ? (stateGroupMessagePatients ?? []).map(pat => pat.patientId) : undefined}
        />
      </FormRow>
      <FormRow title="messaging.messageTitle">
        <InputHandler
          type="TextField"
          name="title"
          editing={true}
          formData={{ document: { title: formValues?.['title'] }, onChange: onChange('title') }}
          placeholder={'messaging.messageTitle'}
        />
      </FormRow>
      <FormRow title="messaging.messageBody">
        <InputHandler
          type="TextArea"
          name="body"
          editing={true}
          formData={{ document: { body: formValues?.['body'] }, onChange: onChange('body') }}
          placeholder={'messaging.messageBody'}
        />
      </FormRow>
      <FormRow title={existingAttachments ? 'messaging.attachments' : 'messaging.addAttachment'}>
        <>
          {existingAttachments && (
            <Container style={{ marginBottom: '1rem' }}>
              {Object.keys(existingAttachments).map(id => {
                const thisAttachmentData = existingAttachments[id];
                const imageDimensions =
                  thisAttachmentData?.type === 'image'
                    ? {
                        minHeight: '2rem',
                        minWidth: '2rem',
                        lineHeight: 0,
                        border: '0.1rem solid ' + colors.lightGray,
                        marginRight: '0.5rem',
                      }
                    : {};
                return (
                  <Item
                    key={id}
                    onClick={
                      thisAttachmentData?.type === 'pdf'
                        ? () => openPDFOnclick(thisAttachmentData)
                        : () => setOpenAttachmentId(id)
                    }
                    style={{ cursor: 'pointer', textAlign: 'center' }}
                  >
                    {
                      <div style={{ ...imageDimensions }}>
                        {thisAttachmentData?.type === 'image' ? (
                          <img
                            style={{ maxWidth: '100%', overflow: 'hidden' }}
                            src={URL.createObjectURL(thisAttachmentData.blob)}
                          />
                        ) : thisAttachmentData?.type === 'pdf' ? (
                          <div className="link">PDF</div>
                        ) : undefined}
                      </div>
                    }
                    <div
                      onClick={e => {
                        e.stopPropagation();
                        setAttachmentDeletionID(id);
                      }}
                      className="link"
                    >
                      {fm('messaging.deleteAttachment')}
                    </div>
                  </Item>
                );
              })}
            </Container>
          )}
        </>
        {attachmentData && (
          <AttachmentForm fm={fm} attachmentData={attachmentData} handleFileChange={handleFileChange} />
        )}
      </FormRow>
      <Container>
        <Item xs={true}>
          <ActionButton
            text="general.cancel"
            onClick={cancelGroupMessage}
            fontSize={16}
            width={18}
            height={4}
            border={false}
          />
        </Item>
        <Item xs={6}>
          <Container justifyContent={'flex-end'}>
            <Item>
              <ActionButton
                text="messaging.send"
                onClick={sendGroupMessage}
                fontSize={16}
                width={18}
                height={4}
                filled
                disabled={!(formValues?.title && formValues.body)}
              />
            </Item>
          </Container>
        </Item>
      </Container>
      <AttachmentDialog attachmentId={openAttachmentId} topic={topic} setOpenAttachmentId={setOpenAttachmentId} />
      <ConfirmationDialog
        open={!!attachmentDeletionID}
        text={<>{fm('messaging.deleteAttachmentConfirmation')}</>}
        cancel={{ callback: () => setAttachmentDeletionID(null) }}
        confirm={{
          callback: () => {
            attachmentDeletionID && deleteAttachment?.(attachmentDeletionID);
            setAttachmentDeletionID(null);
          },
        }}
      />
    </div>
  );
};

interface IGroupMessageForm {
  onChange: (name: string) => (values: TOnChangeValues) => void;
  formValues: Record<string, any> | null | undefined;
  cancelGroupMessage: () => void;
  sendGroupMessage: () => void;
  topic?: TTOPIC;
  attachmentData?: File[];
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  existingAttachments?: Record<string, TAttachmentData> | null;
  deleteAttachment?: (id: string) => void;
}

export default GroupMessageForm;
